import React from "react";
import {useSelector} from "react-redux";
import {RootStore} from "../../../../../../../../store/Store";
import FormHeader from "../../../../../../../Form/FormHeader";
import FormTimesheetItem from "./FormTimesheetItem";
import {getTotalAssignments} from "../../../../../../AdminCalendarEntry/Helpers/calenderEntryHelpers";
import {AssignmentState} from "../../../../../../../../api/grs";

const EndOfShiftTimesheetSection = () => {
    const calendarEntryStore = useSelector((state: RootStore) => state.calendarEntry);

    if (!calendarEntryStore.data) return null;

    const items = getTotalAssignments(calendarEntryStore.data).filter(
        (staff) => staff.state != AssignmentState.Unassigned
    );

    return (
        <>
            <div className="eos-section">
                <FormHeader headerName={"Timesheet"} />
                {items.length > 0 ? (
                    <div className="eos-timesheet">
                        <div className="eos-timesheet-head">Clinician&#39;s Name</div>
                        <div className="eos-timesheet-head">Clinical Grade</div>
                        <div className="eos-timesheet-head">Rate Type</div>
                        <div className="eos-timesheet-head">Rate (£)</div>
                        <div className="eos-timesheet-head eos-time-only">Start Time</div>
                        <div className="eos-timesheet-head eos-time-only">End Time</div>
                        {items.map((item, index) => (
                            <FormTimesheetItem {...item} key={index} />
                        ))}
                    </div>
                ) : (
                    <div className="row ml-0 mr-0 mt-2">
                        <div className="col">
                            <p className="align-items-center align-self-center text-center mb-2">
                                {/* eslint-disable-next-line react/no-unescaped-entities */}
                                No staff members have been assigned to the event
                            </p>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default EndOfShiftTimesheetSection;
